<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
    <template #STATUS="{ visible, params }">
      <Tracker :statusId="params.airway_number" v-if="visible" />
    </template>
  </cTable>
</template>

<script>
import {
  getList,
  updateFile,
  inboundHK,
  joinHK
} from "@/api/order/hongKongPlus";

import cTable from "@/base/common/index";
import Tracker from "@/base/order_tracker";
import {getSelectType} from "@/api/public";

export default {
  name: "hongKongPlus",
  components: {
    cTable,
    Tracker
  },
  data() {
    return {
      methods: {
        list: getList,
        beforeHandleList: ({ data }) => {
          return data;
        },
        updateFile,
        inboundHK,
        joinHK
      },
      config: {},
      modals: {
        import: {
          methods: {
            ok({ row, close }) {
              if (!row.file) {
                this.$Message["error"]({
                  background: true,
                  content: this.$t("select") + this.$t("files"),
                  duration: 5
                });
                return;
              }
              let data = new FormData();
              data.append("file", row.file);
              data.append("time", row.time);
              this.$page.handleRequestMethods("updateFile", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            title: this.$t("import"),
            formBind: {
              labelWidth: 80
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "time cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [{ time: 24 }, { file: 24 }],
          fields: [
            {
              name: () => this.$t("date"),
              key: "time",
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("date"),
              bind: {
                options: {
                  disabledDate: () => false
                }
              }
            },
            {
              key: "file",
              name: () => "Excel" + this.$t("files"),
              component: "Upload",
              bind: {
                fileName: true,
                isButton: true,
                type: "select"
                // accept: ".xlsx,.xls"
              },
              methods: {
                beforeUpload({ file, row }) {
                  row["file"] = file;
                  return false;
                }
              }
            }
          ]
        },
        inbound: {
          methods: {
            ok({ row, close }) {
              const data = {
                awl_time: row.awl_time,
                airway_number: this.$page.selectAll
                  .map(item => item.airway_number)
                  .join()
              };
              this.$page.handleRequestMethods("inboundHK", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true
            },
            title: this.$t("batch") + this.$t("inbound"),
            formBind: {
              labelWidth: 80
            },
            rules: {
              awl_time: [
                {
                  required: true,
                  message: "time cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [{ awl_time: 24 }],
          fields: [
            {
              name: () => this.$t("time"),
              key: "awl_time",
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("time"),
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                }
              }
            }
          ]
        },
        showStatus: {
          contentSlot: "STATUS",
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              sticky: true
            }
          },
          footer: {
            show: () => false
          }
        }
      },
      footer: {
        show: () => false
      },
      header: {
        config: {
          custom: false
        },
        searchs: [{
          key: "orderType",
          placeholder() {
            return this.$t("select") + this.$t("exlType");
          },
          component: "Select",
          options: [{
            value: 1, label: '已完结'
          }, {
            value: 2, label: '待处理'
          }],
          methods: {
            'on-change': v => {
              this.$refs['table'].getList();
            }
          }
        },],
        btns: {
          list: [
            {
              name: () => this.$t("import"),
              type: "importFun",
              fnName: "importFun",
              bind: {
                icon: "md-cloud-upload",
                type: "primary"
              }
            },
						{
						  name: () =>
						    this.$t("download_tem"),
						  type: "down",
						  fnName: "down",
						  bind: {
								icon: "md-download",
						    type: "warning"
						  }
						},
            {
              name: () => this.$t("batch") + this.$t("inbound"),
              type: "inboundFun",
              fnName: "inboundFun",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
            },
            {
              name: () =>
                this.$t("batch") + this.$t("join") + this.$t("packing"),
              type: "joinFun",
              fnName: "joinFun",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning"
              }
            },
          ],
          methods: {
						down(){
							window.open('https://oms.vnlin.com/excel/tmp/hong_kong.xlsx','_black')
						},
            importFun() {
              this.getModal("import").open();
            },
            inboundFun() {
              this.getModal("inbound").open();
            },
            joinFun() {
              const data = {
                airway_number: this.selectAll
                  .map(item => item.airway_number)
                  .join()
              };
              this.$Modal.confirm({
                title:
                  this.$t("whether") + this.$t("join") + this.$t("packing"),
                width: 300,
                onOk: () => {
                  this.handleRequestMethods("joinHK", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("date"),
          key: "date_day",
          width: 120
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          width: 120
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          minWidth: 80
        },
        {
          name: () => "CNB" + this.$t("Odd_Numbers"),
          key: "airway_number",
          minWidth: 120
        },
        {
          name: () => this.$t("customsBill"),
          key: "packing_number",
          minWidth: 150
        },
        {
          name: () => this.$t("bagNum"),
          key: "package_number",
          minWidth: 150
        },
        {
          name: () => this.$t("agentT"),
          key: "agent",
          minWidth: 100
        },
        {
          name: () => this.$t("trajectory") + this.$t("exlType"),
          key: "trace_status",
          minWidth: 100,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({ row }) {
              this.$page.getModal("showStatus").open(row, function() {
                this.setTitle(
                  row.airway_number + "(" + this.$t("trajectory") + ")"
                );
              });
            }
          }
        },
        {
          name: () => this.$t("trajectory") + this.$t("time"),
          key: "trace_time",
          minWidth: 110
        }
      ]
    };
  }
};
</script>
